/* jshint esversion: 6 */

import React, {Fragment} from 'react';
import PropTypes from 'prop-types';

class WebsiteWidgetDropdown extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedItem: '',
    };
    this.items = 0;
  }

  render() {
    const {prompt, options} = this.props;
    const {selectedItem} = this.state;
    const items = [[`${prompt} *`, '']].concat(options);

    return (
      <select
        name="option_data"
        id="option_data"
        onChange={(e) => this.setSelected(e)}
        value={selectedItem}
        required>
        {items.map((i) => this.renderItem(i))}
      </select>
    );
  }

  setSelected(e) {
    this.setState({selectedItem: e.target.value});
  }

  renderPrompt() {
    if (this.props.prompt.length === 0) return 'Please select one';

    return this.props.prompt;
  }

  renderItem(i) {
    return (
      <option
        key={this.items++}
        value={i[1]}>
        {i[0]}
      </option>
    );
  }
}

WebsiteWidgetDropdown.propTypes = {
  prompt: PropTypes.string,
  options: PropTypes.array,
};

export default WebsiteWidgetDropdown;
